require('cross-fetch/polyfill');

const { Mixin, strategies } = require('hops-mixin');
const fetchJson = require('./fetchJson');

class HopsFetchRuntimeMixin extends Mixin {
  configureFetch(fetch) {
    const credentials =
      process.env.NODE_ENV === 'production' ? 'same-origin' : 'include';

    return (input, init) => {
      const request = new Request(input, {
        credentials,
        ...init,
      });

      return fetch(request);
    };
  }

  fetch(...fetchArgs) {
    return this.configureFetch(global.fetch)(...fetchArgs);
  }

  fetchJson(input, options = {}) {
    const { fetch } = this;

    return fetchJson(input, { ...options, fetch });
  }
}

HopsFetchRuntimeMixin.strategies = {
  configureFetch: strategies.sync.pipe,
  fetch: strategies.async.override,
  fetchJson: strategies.async.callable,
};

module.exports = HopsFetchRuntimeMixin;
